var _style, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBanner1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1333 907",
    style: {
      enableBackground: "new 0 0 1333 907"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#522E86;}\n\t.st2{fill:#5F2EA4;}\n\t.st3{fill:#382157;}\n\t.st4{fill:#EA9322;}\n\t.st5{fill:#4B2B76;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -29,
    className: "st0",
    width: 1457.5,
    height: 908
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: -1,
    className: "st1",
    width: 70,
    height: 64
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1387.5,
    y: -1,
    className: "st2",
    width: 70,
    height: 64
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: -1,
    className: "st3",
    width: 70,
    height: 64
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 35,
    className: "st4",
    width: 70,
    height: 64
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: -29,
    className: "st3",
    width: 1475,
    height: 941
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 1.1,
    y: 254,
    className: "st2",
    width: 68.3,
    height: 64
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 1.1,
    y: 702,
    className: "st2",
    width: 68.3,
    height: 64
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 69.3,
    y: 766,
    className: "st5",
    width: 68.3,
    height: 64
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 69.3,
    y: 382,
    className: "st5",
    width: 68.3,
    height: 64
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 1.1,
    y: 510,
    className: "st2",
    width: 68.3,
    height: 64
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 1.1,
    y: 190,
    className: "st5",
    width: 68.3,
    height: 64
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 1099.6,
    y: 682,
    className: "st5",
    width: 63.4,
    height: 57
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 1036.2,
    y: 625,
    className: "st2",
    width: 63.4,
    height: 57
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 1099.6,
    y: 473,
    className: "st2",
    width: 63.4,
    height: 57
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 1036.2,
    y: 416,
    className: "st5",
    width: 63.4,
    height: 57
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 1099.6,
    y: 216,
    className: "st2",
    width: 63.4,
    height: 57
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 1099.6,
    y: 159,
    className: "st5",
    width: 63.4,
    height: 57
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 1099.6,
    y: 739,
    className: "st4",
    width: 63.4,
    height: 57
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner1);
export default __webpack_public_path__ + "static/media/banner1.389baeff8e4c3a867a7c9b92aa908d22.svg";
export { ForwardRef as ReactComponent };